import { Injectable, Injector } from '@angular/core'
import { Http, Response } from '@angular/http'
import { Router } from '@angular/router'
import { Observable, Store, Types, Api, TokenName } from '../store'

@Injectable()

export class BackService {

  // Router is resolved lazily via Injector: constructor-injecting it here
  // creates a DI cycle (APP_INITIALIZER → InitializeService → BackService →
  // Router → ApplicationRef → APP_INITIALIZER) that breaks bootstrap.
  constructor (private http: Http, private store: Store<any>, private injector: Injector) {}

  public post(Api: string, data: any, loading: string = Api): Observable<any> {
    this.store.dispatch({type: Types.UpdateState, payload: { loading: loading }})
    return this.http.post(
      Api, JSON.stringify({ data: data })
    ).map(this.extractData).catch(this.handleError).finally(() => {
      this.onEnd()
    })
  }

  public get(Api: string, loading: string = Api): Observable<any> {
    this.store.dispatch({type: Types.UpdateState, payload: { loading: loading }})
    return this.http.get(Api).map(this.extractData).catch(this.handleError).finally(() => {
      this.onEnd()
    })
  }

  private extractData(res: Response): any {
    const body = res.json()
    return body.data || null
  }

  private handleError = (error: Response | any) => {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body.error || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    console.log(errMsg)
    if (error.status === 401 && localStorage.getItem(TokenName) && this.isSessionRequest(error.url)) {
      localStorage.removeItem(TokenName)
      this.store.dispatch({ type: Types.LogOut })
      this.redirectToRoot(error.url)
    }
    return Observable.throw(errMsg)
  }

  // A stored token only counts as "gone bad" when the failing request actually
  // carried it. The anonymous (pre-auth) endpoints — login, register, slug
  // availability — legitimately 401 (wrong slug/password/signup-code) while a
  // valid session token is still stored (e.g. a logged-in user opening the
  // register page in another tab). A 401 from one of those must not tear down
  // the live session, so auto-logout is scoped to authenticated requests only.
  private isSessionRequest(url: string): boolean {
    const anonymous = [Api.auth.login, Api.master.checkDbAvailable, Api.master.register]
    return !anonymous.some(e => !!url && url.endsWith(e))
  }

  private redirectToRoot(url: string): void {
    // The boot token-refresh (logInByToken) runs in APP_INITIALIZER, before the
    // router outlet exists — navigating there rejects as an unhandled promise.
    // Skip it: initialize.service's catch owns the boot-time token clear and
    // Angular's initialNavigation routes the now-anonymous app to '/'. Guard the
    // returned promise regardless so a late rejection never surfaces unhandled.
    if (url && url.endsWith(Api.auth.logInByToken)) { return }
    const nav: any = this.injector.get(Router).navigate(['/'])
    if (nav && nav.catch) { nav.catch(() => undefined) }
  }

  private onEnd(): void {
    this.store.dispatch({type: Types.UpdateState, payload: { loading: null }})
  }

}



// WEBPACK FOOTER //
// ./src/app/services/back.service.ts